<template>
    <line-graph
        :graph-data="graphData"
        :options="options"
        name="lighthouse-test-results"
    ></line-graph>
</template>

<script>
export default {
    name: "SeoTestResultsLighthouseGraph",
    props: {
        records: {
            type: Array
        }
    },
    data(){
        return {
            graphData: {
                datasets: [],
                labels: [],
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            }
        }
    },
    mounted: function(){
        const records = this.records
        const labels = records.map(record => record.created_at_diff)
        
        this.graphData.labels = labels;
        this.graphData.datasets.push({
            label: 'Performance',
            data: records.map(record => record.lighthouse_performance_score),
            fill: false,
            borderColor: 'rgb(0, 179, 48)',
            tension: 0.1
        });
        this.graphData.datasets.push({
            label: 'Accessibility',
            data: records.map(record => record.lighthouse_accessibility_score),
            fill: false,
            borderColor: 'rgb(193, 67, 5)',
            tension: 0.1
        });
        this.graphData.datasets.push({
            label: 'Best Practices',
            data: records.map(record => record.lighthouse_best_practices_score),
            fill: false,
            borderColor: 'rgb(255, 154, 0)',
            tension: 0.1
        });
        this.graphData.datasets.push({
            label: 'SEO',
            data: records.map(record => record.lighthouse_seo_score),
            fill: false,
            borderColor: 'rgb(75, 192, 192)',
            tension: 0.1
        });
    }
}
</script>